import { useContext, useMemo } from 'react';

import { Container } from '../common';
import type { EventTypeEvaluationsContextType } from '../context';
import { EventTypeEvaluationsProvider } from '../context';
import { UserContext } from '~/dashboard/context';
import { BusinessUpdatedTabs } from './BusinessUpdatedTabs';
import { useRiskData } from '../../RiskRatingCard/useRiskData';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { hasWatchlistServiceConfigured } from '../../utils/cardDataChecks';
import { BusinessUpdatedOverview } from './BusinessUpdatedOverview';

const BusinessUpdated = (props: EventTypeEvaluationsContextType) => {
  const { evaluation } = props;
  const { featureFlags, permissions } = useContext(UserContext);
  const hasReadApplicationVersionsPermission = !!permissions?.['READ:ApplicationVersions:null'];
  /* ---------- CRA Logic ---------- */
  const {
    showRiskTab: shouldRenderRiskTab,
    ...riskData
  } = useRiskData({
    riskScoreData: evaluation.final_response.summary?.risk_score,
  });

  const {
    showRiskTab: shouldRenderSessionRiskTab,
    ...sessionRiskData
  } = useRiskData({
    riskScoreData: evaluation.final_response.summary?.session_risk_score,
  });

  /* ---------- vvvvvvvvv ---------- */

  const shouldRenderWatchlistTab = useMemo(() => (
    shouldRenderCard(
      hasWatchlistServiceConfigured(evaluation),
      Boolean(featureFlags?.removeEmptyCards),
    )
  ), [evaluation, featureFlags]);

  return (
    <EventTypeEvaluationsProvider {...props}>
      <Container
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
      >
        {shouldRenderRiskTab || shouldRenderSessionRiskTab || shouldRenderWatchlistTab
          ? (
            <BusinessUpdatedTabs
              canViewRiskFormula={hasReadApplicationVersionsPermission}
              riskData={riskData}
              sessionRiskData={sessionRiskData}
              shouldRenderRiskTab={shouldRenderRiskTab}
              shouldRenderSessionRiskTab={shouldRenderSessionRiskTab}
              shouldRenderWatchlistTab={shouldRenderWatchlistTab}
            />
          ) : (
            <BusinessUpdatedOverview />
          )}
      </Container>
    </EventTypeEvaluationsProvider>
  );
};

export default BusinessUpdated;
